module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="effect-name">Resize</div>\n<div class="scale-range-region"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/properties/ScaleEffectPropertiesView.tpl
// module id = 1750
// module chunks = 0